import {useContext, useLayoutEffect, useState} from 'react';
import BridgeContext from '../context/BridgeContext';

function useSupport(name: string): boolean | undefined {
    const {support} = useContext(BridgeContext);

    const [supported, setSupported] = useState<boolean | undefined>(undefined);
    useLayoutEffect(() => {
        support(name).then((result) => {
            setSupported(result);
        }, (reason) => {
            console.warn('bridge support failure reason:', reason);
        });
    }, [support, name]);

    return supported;
}

export default useSupport;
